import getCategories from './getCategories'
import Form from './Form'
import cdi from './cdi'

export const getCategoriesService = getCategories
export const FormService = Form
export const cdiService = cdi